import { getColorByEnv } from "../../utils/GetColorByEnv";
import './DisplayEnv.scss';

export const DisplayEnv = ({
  code,
  name,
}: {
  code: string | undefined;
  name: string | undefined;
}) => {
  const iconColor = getColorByEnv(code);
  return (
    <div
      className="flex align-items-center"
      style={{ fontSize: "inherit" }}
    >
      <div className="env-chip">
      {iconColor && (
        <div>
          <i
            className="pi pi-circle-fill mr-2"
            style={{ color: iconColor, fontSize: "inherit" }}
          ></i>
        </div>
      )}
      <div style={{ fontSize: "inherit", height: "inherit" }}>{name}</div>
      </div>
    </div>
  );
};
